import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TableInstance } from 'react-table';

interface EditableDataTableProps<T extends object> {
  instance: TableInstance<T>;
  noDataMessage: string;
  isDiffingMode: boolean;
  isDraft: boolean;
  rejectedAndEditMode: boolean;
}
export function EditableDataTable<T extends object>({
  instance,
  noDataMessage,
  isDiffingMode,
  isDraft,
  rejectedAndEditMode,
}: EditableDataTableProps<T>) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = instance;
  const headers = headerGroups.map(headerGroup => (
    <TableRow {...headerGroup.getHeaderGroupProps()}>
      {headerGroup.headers.map(column => (
        <TableCell
          align={column.align}
          {...column.getHeaderProps({
            style: {
              width: `${column.width}px`,
              minWidth: `${column.minWidth}px`,
            },
          })}
        >
          <Box component='span'>{column.render('Header')}</Box>
        </TableCell>
      ))}
    </TableRow>
  ));
  const rows = page.length ? (
    page.map(row => {
      prepareRow(row);
      const isValuesSame =
        row.values.floor === row.values.diffingFloor && row.values.rebate === row.values.diffingRebate;
      const showDiff = (isDiffingMode || isDraft) && !rejectedAndEditMode;
      const removedValues = isNaN(row.values.diffingFloor) || isNaN(row.values.diffingRebate);
      const newValues = isNaN(row.values.floor) || isNaN(row.values.rebate);
      const backgroundColor = showDiff
        ? !isValuesSame
          ? newValues
            ? '#ff000040'
            : removedValues
            ? '#00d8004f'
            : '#fbfb5861'
          : 'transparent'
        : 'transparent';

      return (
        <TableRow {...row.getRowProps()} sx={{ backgroundColor }}>
          {row.cells.map(cell => (
            <TableCell align={cell.column.align} {...cell.getCellProps()}>
              {cell.render('Cell')}
            </TableCell>
          ))}
        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell colSpan={3}>
        <Typography>{noDataMessage}</Typography>
      </TableCell>
    </TableRow>
  );

  return (
    <TableContainer>
      <Table size='small' stickyHeader {...getTableProps()}>
        <TableHead>{headers}</TableHead>
        <TableBody {...getTableBodyProps()}>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
}
